import React from "react";
import GeneralService from "../services/general-service";
import NoticeBoardService from "../services/notice-board-service";

const maxAttachments = 1;
const maxFileSizeInMb = 10;
const maxFileSize = maxFileSizeInMb * 1024 * 1024;

export const getNoticeBoardData = (previousData?: NoticeBoardCreated) => {
  const data: NoticeBoardFormData = {
    formData: {
      title: previousData?.noticeBoardItem.title || null,
      image: previousData?.noticeBoardItem.imageUrl || null,
      imageId: previousData?.noticeBoardItem.imageId || null,
      attachment: previousData?.noticeBoardItem.attachment || null,
    },
    classData: [],
  };

  return data;
};

export const checkIfAllFormHasFilled = (
  data: NoticeBoardFormData,
  validations: object,
  allowSubmit: boolean,
  setAllowSubmit: React.Dispatch<React.SetStateAction<boolean>>
) => {
  if (
    data &&
    data.formData &&
    data.formData.title &&
    data.formData.attachment &&
    data.formData.attachment.id &&
    data.formData.imageId &&
    data.classData.length > 0 &&
    Object.keys(validations).length === 0
  ) {
    setAllowSubmit(true);
  } else if (allowSubmit) {
    setAllowSubmit(false);
  }
};

export const forceRemovePreviewImage = (
  id: string,
  data: NoticeBoardFormData,
  setData: React.Dispatch<React.SetStateAction<NoticeBoardFormData>>
) => {
  const newData = Object.assign({}, data);
  delete newData.formData[id];
  delete newData.formData['imageId'];

  setData(newData);
};

export const deleteAttachment = (
  id: number,
  data: NoticeBoardFormData,
  setData: React.Dispatch<React.SetStateAction<NoticeBoardFormData>>,
  validations: object = undefined,
  setValidations: (value: React.SetStateAction<{}>) => any = undefined
) => {
  const newData = Object.assign({}, data);
  newData.formData.attachment = null;
  const attachmentsLength = newData.formData.attachment ? 1 : 0;

  if (validations && setValidations && Object.keys(validations).includes('attachment') && attachmentsLength <= maxAttachments) {
    const newValidations = Object.assign({}, validations);
    delete newValidations['attachment']
    setValidations(newValidations);
  }

  setData(newData);
};

export const handleStudentChange = (
  selectedClassrooms: number[],
  selectedStudents: number[],
  data: NoticeBoardFormData,
  setData: React.Dispatch<React.SetStateAction<NoticeBoardFormData>>
) => {
  const newData = {
    formData: { ...data.formData },
    classData: selectedClassrooms,
    studentData: selectedStudents,
  };

  setData(newData);
};

export const handleFormOnChange = async (
  e: React.ChangeEvent<
    HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
  >,
  validations: object,
  data: NoticeBoardFormData,
  setValidations: (value: React.SetStateAction<{}>) => any,
  setData: (value: React.SetStateAction<NoticeBoardFormData>) => any,
  setIsLoadingImage: React.Dispatch<React.SetStateAction<boolean>>,
  setIsLoadingAttachment: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const generalService = new GeneralService();
  const id = e.target.id;
  let value = e.target.value;
  const type = e.target.type;
  const eventType = e.type;

  const newValidations = Object.assign({}, validations);

  if (!value && id !== 'attachment' && id !== 'image')
    newValidations[id] = 'Campo obrigatório.';
  else if (id !== 'attachment' && id !== 'image') delete newValidations[id];

  const newData = Object.assign({}, data);
  if (value && type === 'file' && id === 'image' && e.type !== 'blur') {
    setIsLoadingImage(true);

    const rawFiles = (e.target as HTMLInputElement).files;
    const hasFileAboveThreshold = Object.keys(rawFiles).some(key => rawFiles[key].size > maxFileSize);

    if (hasFileAboveThreshold) {
      newValidations['image'] = `O tamanho máximo da imagem é ${maxFileSizeInMb}MB.`;
    } else {
      delete newValidations['image'];
      const files = await generalService.uploadFile(rawFiles);
      newData.formData['image'] = files[0].location;
      newData.formData['imageId'] = files[0].id;
    }

    setIsLoadingImage(false);
  } else if (
    value &&
    type === 'file' &&
    id === 'attachment' &&
    e.type !== 'blur'
  ) {
    setIsLoadingAttachment(true);

    const rawFiles = (e.target as HTMLInputElement).files;
    const oldLength = newData.formData.attachment ? 1 : 0;
    const inputLength = rawFiles.length;
    const newLength = oldLength + inputLength;

    const hasFileAboveThreshold = Object.keys(rawFiles).some(key => rawFiles[key].size > maxFileSize);

    if (hasFileAboveThreshold) {
      newValidations['attachment'] = `O tamanho máximo de cada anexo é ${maxFileSizeInMb}MB.`;
    }
    else if (newLength > maxAttachments) {
      newValidations['attachment'] = `Quantidade máxima de anexos é ${maxAttachments}.`;
    }
    else {
      delete newValidations['attachment']
      const files = await generalService.uploadFile(rawFiles);

      newData.formData.attachment = files[0];
    }

    setIsLoadingAttachment(false);
  } else if (type !== 'file') {
    newData.formData[id] = value;
  }

  if (type === 'file' && ['attachment', 'image'].includes(id) && eventType === 'blur') {
    e.target.value = null;
  }

  setValidations(newValidations);
  setData(newData);
};

export const deleteNoticeBoard = (
  noticeBoardId: string,
  setModalContent: (content: ModalContent) => any,
  setToastContent: (content: ToastContent) => void,
  navigate: any
) => {
  const noticeBoardService = new NoticeBoardService();
  setModalContent({
    title: 'Deletar mural',
    modalContent: React.createElement(
      'p',
      null,
      'Deseja realmente deletar o mural?'
    ),
    submitButtonTitle: 'confirmar deleção',
    submitButtonType: 'primary',
    submitData: null,
    onSubmitButtonClick: () =>
      noticeBoardService
        .deleteNoticeBoard(noticeBoardId)
        .then(() => {
          setToastContent({
            isOpen: true,
            text: 'mural deletado!',
            type: 'success',
          });
          navigate('/mural/listar');
        })
        .catch(() => {
          setToastContent({
            isOpen: true,
            text: 'Houve um erro ao deletar o mural.',
            type: 'error',
          });
        }),
    isOpen: true,
  });
};
